/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import TransactionalMessageModel, { TransactionalMessageUpdateType } from 'cio/models/transactional-message';
import AnalyticsService from 'cio/services/analytics';

interface TransactionalNameAndDescriptionEditorArgs {
  message: TransactionalMessageModel;
}

export default class TransactionalNameAndDescriptionEditor extends Component<TransactionalNameAndDescriptionEditorArgs> {
  @service analytics!: AnalyticsService;
  @tracked isEditing = false;

  @action
  toggleEditing() {
    this.isEditing = !this.isEditing;

    if (this.isEditing) {
      this.analytics.track('transactional', 'edit_started', {
        editType: 'details',
        model: this.args.message,
      });
    }
  }

  @action
  async onSave(message: TransactionalMessageModel) {
    message.set('updateType', TransactionalMessageUpdateType.NameAndDescription);
    await message.save();
    this.isEditing = false;
  }
}
